import { FeatureFlags } from '@models/featureflags.model';

export class FetchFeatureflags {
  static readonly type = '[Featureflags] Fetch Featureflags';
}

export class FetchFeatureflagsSuccess {
  static readonly type = '[Featureflags] Fetch Featureflags Success';
  constructor(public readonly featureFlags: FeatureFlags) {}
}

export class FetchFeatureflagsFailure {
  static readonly type = '[Featureflags] Fetch Featureflags Failure';
}

export class UpdateFeatureflag {
  static readonly type = '[Featureflags] Update Featureflag';
  constructor(public readonly key: string, public readonly value: boolean) {}
}

export class UpdateFeatureflagSuccess {
  static readonly type = '[Featureflags] Update Featureflag Success';
  constructor(public readonly featureFlags: FeatureFlags) {}
}

export class UpdateFeatureflagFailure {
  static readonly type = '[Featureflags] Update Featureflag Failure';
}
